import script from "./WaterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WaterPage.vue?vue&type=script&setup=true&lang=js"

import "./WaterPage.vue?vue&type=style&index=0&id=86d1c478&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d1c478"]])

export default __exports__